/**
 * Development CLOUD: the deployed blume-method-testing project (demos and
 * shared-state work, NOT the emulator dev loop). `useEmulators: false`, so
 * `src/app/core/firebase.ts` talks straight to the cloud project - the
 * emulator strings stay empty and are never read.
 *
 * Config from the registered web app on blume-method-testing (mirrors
 * blume-tools' environment.ts). All three env files share one shape so
 * `core/firebase.ts` type-checks against each.
 */
export const environment = {
  production: false,
  useEmulators: false,
  firebase: {
    projectId: 'blume-method-testing',
    apiKey: 'AIzaSyAZyjwZRUPoYcAVzfvMq0oUDD9m4ZYC-Ys',
    appId: '1:1004422004526:web:d900381c888c0450fcc4bf',
    authDomain: 'blume-method-testing.firebaseapp.com',
  },
  emulators: {
    firestore: '',
    auth: '',
    functions: '',
  },
  region: 'us-east4',
};
